import {
  // call,
  put,
  select,
} from "redux-saga/effects";
import flatten from "flat";

import { SET_FLAG } from "../CONSTANTS";
// import restoreFromUrl from "./psalms/restoreFromUrl";
import selectors from "model/selectors";
import * as CLIENTS from "model/subsystems/clients/CONSTANTS";
import { CONSTANTS as ACCESS } from "@lifepay/redux-subsystem-access";

export default function* onUserLogin({ gqlclient }) {
  const permissions = flatten(
    (yield select(selectors.user.roles$$)).toObject()
  );
  yield put({ type: ACCESS.SET_PERMISSIONS, payload: permissions });
  yield put({
    type: SET_FLAG,
    payload: { key: "permissionsClarified", value: true },
  });
  yield put({ type: CLIENTS.START });
  yield put({ type: CLIENTS.START_LISTEN_FOR_CALLS });
  // yield call(restoreFromUrl, { gqlclient });
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/saga/onUserLogin.js